import React, { FC, useEffect, useState } from 'react';
import styles from '../journey-explorer.module.scss';
import { SavedViewState } from '../../../../models/journey-explorer/journey-explorer';
import { viewStateLink } from '../journey-view-state';

const COPIED_MS = 2000;

interface HistoryButtonsProps {
	canBack: boolean;
	canForward: boolean;
	onBack: () => void;
	onForward: () => void;
}

export const HistoryButtons: FC<HistoryButtonsProps> = ({ canBack, canForward, onBack, onForward }) => (
	<div className={styles.history}>
		<button
			type="button"
			className={styles.history_button}
			aria-label="Back"
			title="Back"
			disabled={!canBack}
			onClick={onBack}
		>
			‹
		</button>
		<button
			type="button"
			className={styles.history_button}
			aria-label="Forward"
			title="Forward"
			disabled={!canForward}
			onClick={onForward}
		>
			›
		</button>
	</div>
);

export const CopyLinkButton: FC<{ state: SavedViewState | null }> = ({ state }) => {
	const [status, setStatus] = useState<'idle' | 'copied' | 'failed'>('idle');

	useEffect(() => {
		if (status === 'idle') {
			return;
		}
		const timer = setTimeout(() => setStatus('idle'), COPIED_MS);
		return () => clearTimeout(timer);
	}, [status]);

	const copy = async () => {
		if (!state) {
			return;
		}
		try {
			await navigator.clipboard.writeText(viewStateLink(state, window.location.href));
			setStatus('copied');
		} catch {
			setStatus('failed');
		}
	};

	let label = 'Copy link';
	if (status === 'copied') {
		label = 'Link copied';
	} else if (status === 'failed') {
		label = 'Could not copy';
	}

	return (
		<button
			type="button"
			className={styles.compare_button}
			disabled={!state}
			title="Copy a link to this exact view"
			onClick={copy}
		>
			{label}
		</button>
	);
};
